import { render } from "./GdprTerms.vue?vue&type=template&id=56c4bd14&scoped=true&ts=true&lang=pug"
import script from "./GdprTerms.vue?vue&type=script&lang=ts"
export * from "./GdprTerms.vue?vue&type=script&lang=ts"

import "./GdprTerms.vue?vue&type=style&index=0&id=56c4bd14&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./GdprTerms.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/components/gdprterms.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fviews%2FGdprTerms.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56c4bd14"]])

export default __exports__